var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoOnDemand = function SvgIcoOnDemand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M6 4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM2 17V7a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0m18 0V7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0m-5.878-4.145a1 1 0 0 0 .001-1.701l-2.597-1.607a1 1 0 0 0-1.526.85v3.209a1 1 0 0 0 1.525.851z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoOnDemand;